<template>
  <main class="main">
    <v-row>
      <v-col cols="12" md="6" style="background-color: #F5F5F5;">
        <v-card class="pa-5" shaped>
          <v-row id="ticket">
            <v-col>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Producto</th>
                      <th class="text-center" width="8%">Cantidad</th>
                      <th class="text-center" width="8%">Precio</th>
                      <th class="text-center" width="8%">Descuento</th>
                      <th class="text-center" width="16%">Subtotal</th>
                      <th class="text-center" width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in carrito"
                      :key="item.idarticulo"
                      class="text-center"
                    >
                      <td class="text-left">{{ item.nombre }}</td>
                      <td>
                        <v-text-field
                          v-model="item.cantidad"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="item.precioventa"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td class="text-center">
                        <v-text-field
                          class="text-center"
                          v-model="item.descuento"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          :value="(item.cantidad * item.precioventa - item.descuento)| redondear"
                          dense
                          readonly
                        ></v-text-field>
                      </td>

                      <td>
                        <v-btn icon @click="removeItemCart(item)" dense
                          ><v-icon color="red">mdi-close-box</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row justify="center">
            <v-col class="text-right" v-show="carrito.length>0">
              <h3>TOTAL: Q {{ sumatoria || 0.0 | redondear}}</h3>
              <p>Total Descuento: Q {{ totalDescuento || 0.0 }}</p>
              <v-btn
                class="ma-2"
                color="blue-grey darken-2"
                dark
                large
                @click="carrito.splice(0, carrito.length)"
                ><v-icon left>mdi-close</v-icon> VACIAR LISTA
              </v-btn>
              <v-btn
                class="ma-2"
                color="green"
                v-show="sumatoria > 0"
                @click="modalcliente = true"
                dark
                large
                ><v-icon class="mdi-24px" left>mdi-cash-multiple</v-icon>PAGAR Q
                {{ sumatoria || 0.0 | redondear}}</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- PANEL DE PRODUCTOS -->
      <v-col cols="12"  md="6" style="background-color: #F5F5F5;">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Buscar producto...."
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="getProductosActivos"
            :search="search"
          >
            <template v-slot:[`item.stockactual`]="{ item }">
              <p v-if="item.stockactual > 0">{{ item.stockactual }}</p>
              <strong style="color:#757575" v-if="item.stockactual < 1">AGOTADO</strong>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                icon
                color="blue"
                @click="pusCarrito(item)"
                v-if="item.stockactual > 0"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- Modal Seleccionar Cliente -->
    <v-dialog v-model="modalcliente" persistent width="700">
      <v-card>
        <v-card-title class="headline blue text-white">
          <v-icon color="white mdi-24px">mdi-account-circle</v-icon>
          <v-divider class="mx-4" vertical></v-divider>
          DATOS DEL CLIENTE
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-autocomplete
            v-model="editedItem.idestablecimiento"
            :items="getEstablecimientos"
            item-text="nombrecomercial"
            item-value="idestablecimiento"
            outlined
            dense
            @change="setIdEstablecimiento"
            label="Seleccione Establecimiento"
          ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8">
              <v-row>
                <v-col>
                   <v-text-field
                    v-model="editedItemCliente.nit"
                    label="Nit"
                    @change="buscarClienteNit"
                    autofocus
                  ></v-text-field>
                </v-col>
                <v-col>
                <v-text-field
                  v-model="editedItemCliente.codigo"
                  label="Codigo Cliente"
                  @change="buscarClientePorCodigo"
                ></v-text-field>
                </v-col>
              </v-row>
             
            
              <v-text-field
                v-model="editedItemCliente.nombre"
                label="Nombre Cliente"
              ></v-text-field>
              <v-text-field
                v-model="editedItemCliente.direccion"
                label="Dirección"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="editedItem.documento"
                :items="tipo"
                label="Tipo documento"
                @change="buscarVentaPorTipo"              
              ></v-select>
              <v-text-field
                v-model="editedItem.serie"
                label="Serie"
                @change="buscarVentaPorTipo" 
                :disabled="editedItem.documento=='Factura Electrónica'"
              ></v-text-field>
              <v-text-field
                v-model="editedItem.numero"
                label="Número documento"
                :disabled="editedItem.documento=='Factura Electrónica'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-2" @click="modalcliente = false" dark> <v-icon left>mdi-keyboard-backspace</v-icon> Volver</v-btn>
          <v-btn
            class="text-white"
            color="red"
            style="text-decoration:none"
            @click="createCliente"
            v-if="!clienteencontrado"
          >
            REGISTRAR CLIENTE
          </v-btn>
          <v-btn
            class="text-white"
            color="green"
            @click="postVenta"
            v-else
          >
            GENERAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DIALOG PROCESANDO DATA-->
    <v-dialog v-model="procesardatos" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando Solicitud...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSizePaper" width="500">
       <TamanioDocumento :documento="documento"  @opendialog="opendialog"/>
      </v-dialog>

  </main>
</template>

<script>
import currency from "@/utils/currency.js";
import generateXML from "@/utils/xmlFel.js";
import Swal from "sweetalert2";
import axios from "axios";
import findClienteSat from "../Personas/utils/find.cliente";

import dayjs from 'dayjs';
import TamanioDocumento from '../Ventas/TamanioDocumento.vue';

export default {
  components:{
    TamanioDocumento
  },
  name: "PuntodeVenta",
  data() {
    return {
      procesardatos: false,
      search: "",
      documento:{},
      modalcliente: false,
      clienteencontrado: true,
      dialogSizePaper:false,
      idestablecimiento:1,
      headers: [
        { text: "Cod.", align: "center", value: "codigo" },
        { text: "Nombre", value: "nombre" },
        { text: "Ubicacion", value: "ubicacion" },
        { text: "Stock", align: "center", value: "stockactual" },
        { text: "Precio Venta", align: "center", value: "preciosugerido" },
        { text: "Precio Minimo", align: "center", value: "preciominimo" },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      carrito: [],
      tipo: ["Factura Electrónica","Proforma","Recibo"],
      editedItemCliente: {
        nombre: "CONSUMIDOR FINAL",
        nit: "CF",
        codigo:'',
        direccion: "JALAPA",
      },
      defaultItemCliente:{
        nombre: "CONSUMIDOR FINAL",
        nit: "CF",
        codigo:'',
        direccion: "JALAPA",
      },
      carritoObj:{
        cantidad:1,
        preciocompra:0,
        descuento:0,
        precioventa:0,
        total:0,
        idarticulo:1,
      },
      cleancarritoObj:{
        cantidad:1,
        preciocompra:0,
        descuento:0,
        precioventa:0,
        total:0,
        idarticulo:1,
      },
      editedItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        fecha:dayjs().format('YYYY-MM-DD H:mm:ss'), //12:30:05
        serie: "A",
        descuento: 0,
        total: 0,
        documento: "Factura Electrónica",
        estado:'Activo',
        idestablecimiento:1,
        detallefactura:[]
      },
      defaultItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        serie: "A",
        descuento: 0,
        total: 0,
        documento: "Factura Electrónica",
        fecha:dayjs().format('YYYY-MM-DD H:mm:ss'), 
        estado:'Activo',
        idestablecimiento:1,
        detallefactura:[]
      },
      idfactura:false,
    };
  },
  async created() {
    await this.initialize();
   this.editedItem.idestablecimiento =  parseInt( localStorage.getItem('idestablecimiento') )
   
  },
  computed: {
    getProductosActivos() {
      return this.$store.getters.getProductosActivos;
    },
    sumatoria() {
      return currency(
        this.carrito.reduce(
          (total, current) =>
            total +
            (current.cantidad * current.precioventa - current.descuento),
          0
        ),
        {precision:5}
      );
    },
    totalDescuento() {
      return currency(this.carrito.reduce((descuento, current) => descuento + parseFloat(current.descuento),0));
    },
    getTokenUser(){
      return this.$store.getters.getTokenUser
    },
    getEstablecimientos(){
      return this.$store.getters.getEstablecimientosActivas
    },
    getUrlPdf(){
      return this.$store.getters.getUrlPdf
    }
  },
  methods: {
    calculos(item) {
      const producto = this.getProductosActivos.find(element=>element.idarticulo === item.idarticulo)
      const index = this.carrito.indexOf(item)
      //Validamos que la cantidad no supere al stock
      const stockActual = parseFloat(producto.stockactual)
      if(stockActual>=item.cantidad){
        this.carrito[index].total = currency( (parseFloat(item.cantidad)*parseFloat(item.precioventa))-parseFloat(item.descuento) ,{precision:5})
      }else{
        item.cantidad=parseFloat(producto.stockactual)
        Swal.fire("Cantidad maxima que puede vender es de "+producto.stockactual);
      }
      //Validamos que el precio de venta no supere al preciominimo 
     
      if(parseFloat(this.carrito[index].precioventa)<parseFloat(producto.preciominimo)){
        item.precioventa=producto.preciominimo
        Swal.fire("El precio minimo del producto es Q "+producto.preciominimo);
      }
      if(this.carrito[index].descuento.length==0){
        item.descuento=0;}
      if(item.cantidad<0.01){
        item.cantidad=1}  
    },
    setIdEstablecimiento(){
        localStorage.setItem('idestablecimiento',this.editedItem.idestablecimiento)
    },
    async initialize() {
      await this.$store.dispatch("setProductMostSelledItem");
      await this.$store.dispatch('setAllEstablecimientos') 
      await this.$store.dispatch("setClientes");
      await this.$store.dispatch('setAllVentas');  
      this.$store.dispatch("setNavigation");
      this.buscarVentaPorTipo()
    },
    opendialog(){
      const establecimiento = this.getEstablecimientos.find(element => element.idestablecimiento == this.editedItem.idestablecimiento)
         
         this.documento = {...this.editedItem};
         this.documento.idfactura = this.idfactura;
         this.documento.idestablecimiento = {...establecimiento};
         this.documento.idpersona = {...this.editedItemCliente};
       
        this.dialogSizePaper=!this.dialogSizePaper;
    },
    async postVenta() {
      
      if(!this.procesardatos){
        this.editedItem.total = this.sumatoria
        this.procesardatos = true
        //DATOS FEL
        if(this.editedItem.documento==='Factura Electrónica'){

          const establecimiento = this.getEstablecimientos.find(element => element.idestablecimiento == this.editedItem.idestablecimiento)
         let felgenerado = await generateXML(this.editedItem.codestablecimiento,establecimiento,this.editedItemCliente,this.carrito,this.editedItem.total)
         
         this.validarDTE(felgenerado)
          //FIN DATOS FEL
        }else{
          //Post Crear Venta
          await this.createVenta()
        }
         
        
      }
      
    },
    async validarDTE(xml){
     
      const establecimiento = this.getEstablecimientos.find(element => element.idestablecimiento == this.editedItem.idestablecimiento)
      const factura = await axios.post(`https://cdn.microsystems.com.gt/fel/felSAT.php?op=validarFel`,{'xmlfel':xml,'establecimiento':establecimiento})
      
      if(factura.data.Codigo==1){
        //this.editedItem.fecha = factura.data.Fecha_de_certificacion
        this.editedItem.numero = parseInt(factura.data.NUMERO)
        this.editedItem.serie = factura.data.Serie
        this.editedItem.autorizacion = factura.data.Autorizacion
        //Post Crear Venta
        await this.createVenta()
      }else{
         this.procesardatos = false;
        this.modalcliente=false;
        this.errorSwal(factura.data.Mensaje)
      }
    },
    async createVenta(){
        //POST VENTA
        this.editedItem.detallefactura = this.carrito
         
        try {
            const {data} = await this.$store.dispatch("createVenta",this.editedItem)
            this.idfactura = data.idfactura
            this.createDetalleVenta()
        } catch (error) {
          this.procesardatos = false
          console.log(error)
          this.errorSwal("Error al registrar la venta")
        }
           
        
    },
    async createDetalleVenta(){
      
      const carrito = []
      this.carrito.forEach(item=>{
         item.idfactura = this.idfactura  
         carrito.push(item)  
       })
     
      try {
        await axios.post(`${this.$store.state.urlapi}/facturadetalles/`,carrito,this.getTokenUser) 
         this.procesardatos = false;
         this.opendialog()
         this.modalcliente=false;
      } catch (error) {
        this.procesardatos = false;
        this.errorSwal('Error al generar documento')
      }

      //Actualizamos el stock si es una factura ó Recibo
      if(this.editedItem.documento!='Proforma'){
        
        await this.$store.dispatch('decrementStock',this.idfactura)
        await this.$store.dispatch("setProductMostSelledItem");
      } 
      await this.$store.dispatch('setAllVentas');

      this.clearData()
    },
    clearData(){
      //defaultItemCliente
      //const data = this.$store.getters.getClientes('CF');
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.idestablecimiento =  parseInt( localStorage.getItem('idestablecimiento') )
      this.editedItemCliente = Object.assign({}, this.defaultItemCliente);
      this.carrito=[]
    },
    buscarClientePorCodigo(){
      
      this.editedItemCliente.nit = this.editedItemCliente.nit.replace(/-/, "");
      const cliente = this.$store.getters.getClientePorCodigo(
                        this.editedItemCliente.codigo.toUpperCase()
                      );            
      this.registrarCliente(cliente)               
    },
    buscarClienteNit() {
      
      this.editedItemCliente.nit = this.editedItemCliente.nit.replace(/-/, "");
      const cliente = this.$store.getters.getClientes(
                        this.editedItemCliente.nit.toUpperCase()
                      );
                      
      this.registrarCliente(cliente)          
      
    },
    async registrarCliente(data){
       
       
        if (data) {
        
          this.clienteencontrado = true;
          this.editedItem.idpersona = data.idpersona;
          this.editedItem.cliente = data.nombre;

          this.editedItemCliente.nit=data.nit.toUpperCase() 
          this.editedItemCliente.nombre = this.editedItem.cliente;
          this.editedItemCliente.direccion = data.direccion;
        } else {
          this.clienteencontrado = false;
          const cliente = await findClienteSat(
            this.editedItemCliente.nit.toUpperCase()
          );
          this.editedItemCliente.nombre = cliente;
        }

      
    },
    async createCliente() {
     const data = await this.$store.dispatch("createCliente", this.editedItemCliente);
     //Registramos el Cliente 
      this.registrarCliente(data)
      //Recargamos el inicio para obtener los clientes
      await this.initialize();
      //Ponemos cliente encontrado en true
      this.clienteencontrado = true;
    },
    //METODOS PARA AGREGAR Y ELIMINAR ELEMENTOS DEL CARRITO 
    pusCarrito(item) {
      const articulo = this.carrito.find(elemento=>elemento.idarticulo ==item.idarticulo );
      //Si es diferente de vacio que inserte el producto
      if (!articulo) {
        this.carritoObj.nombre= item.nombre
        this.carritoObj.cantidad= parseFloat(1)
        this.carritoObj.preciocompra=item.preciocompra
        this.carritoObj.descuento= parseFloat(0.00)
        this.carritoObj.precioventa=parseFloat(item.preciosugerido)
        this.carritoObj.total=(this.carritoObj.cantidad*this.carritoObj.precioventa)
        this.carritoObj.idarticulo=parseInt(item.idarticulo)
        this.carrito.push(this.carritoObj);
      } else {
        this.addItemCart(articulo,item);
      }
      this.carritoObj = Object.assign({}, this.cleancarritoObj)      
    },
    addItemCart(articulo,item) {
     
      if (item.stockactual > articulo.cantidad) {
        articulo.cantidad++
        articulo.total = (articulo.cantidad*articulo.precioventa)
      } else {
        Swal.fire("Cantidad supera a las existencias");
      }
    },
    removeItemCart(item) {
      const index = this.carrito.indexOf(item);
      this.carrito.splice(index, 1);
    },
    buscarVentaPorTipo(){
      const ventas = this.$store.getters.getAllVentas
      //Si el Tipo es = Factura le Asignamos serie FEL

      if(ventas){
        //Filtramos las ventas por tipo
        const filtro = ventas.filter(elemento=>{
          
          if(elemento.documento==this.editedItem.documento&& elemento.estado=='Activo' && elemento.serie==this.editedItem.serie ){
            return elemento
          }
        })
        if(filtro.length==0)this.editedItem.numero = 1
        else{
          //Buscamos el ultimo numero del tipo de documento
          const numeroSiguiente = filtro.sort((item1,item2)=>{
                    return parseInt(item2.numero)-parseInt(item1.numero)
                  })
          this.editedItem.numero = parseInt(numeroSiguiente[0].numero)+1      
        }

      }
    },
    //Notificaciones Swal
    alertDone(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    errorSwal(message) {
      Swal.fire({
        icon: "error",
        title: message,
        text: "El documento no pudo ser procesado intentelo mas tarde",
      });
    },
    infoSwal(message, texto) {
      Swal.fire({
        icon: "info",
        title: message,
        text: texto,
      });
    },
  },
  filters:{
    redondear: function (value) {
    if (!value) return ''
    value = parseFloat(value)
    return currency( value ,{precision:2})
  }
  }
};
</script>
<style scoped>
.main{
  margin-top:-10px;
  height: 100vh;
}
</style>